import React, { useState, useEffect } from "react";

const GRID_SIZE = 20;

export default function Snake() {
  const [snake, setSnake] = useState([[10, 10]]);
  const [food, setFood] = useState([5, 5]);
  const [dir, setDir] = useState([0, -1]); // moving up initially
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    const handleKey = (e) => {
      switch (e.key) {
        case "ArrowUp":
          if (dir[1] !== 1) setDir([0, -1]);
          break;
        case "ArrowDown":
          if (dir[1] !== -1) setDir([0, 1]);
          break;
        case "ArrowLeft":
          if (dir[0] !== 1) setDir([-1, 0]);
          break;
        case "ArrowRight":
          if (dir[0] !== -1) setDir([1, 0]);
          break;
        default:
          break;
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [dir]);

  useEffect(() => {
    if (gameOver) return;
    const interval = setInterval(() => {
      setSnake((prev) => {
        const head = [prev[0][0] + dir[0], prev[0][1] + dir[1]];
        // Hit wall or self
        if (
          head[0] < 0 ||
          head[0] >= GRID_SIZE ||
          head[1] < 0 ||
          head[1] >= GRID_SIZE ||
          prev.some((seg) => seg[0] === head[0] && seg[1] === head[1])
        ) {
          setGameOver(true);
          return prev;
        }
        const newSnake = [head, ...prev];
        if (head[0] === food[0] && head[1] === food[1]) {
          setFood([
            Math.floor(Math.random() * GRID_SIZE),
            Math.floor(Math.random() * GRID_SIZE),
          ]);
        } else {
          newSnake.pop();
        }
        return newSnake;
      });
    }, 150); // Speed
    return () => clearInterval(interval);
  }, [dir, food, gameOver]);

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center font-mono">
      <h1 className="text-white text-3xl font-bold mb-4">
        Snake - Score: {snake.length - 1}
      </h1>
      <div
        className="bg-black border-4 border-slate-700 relative"
        style={{ width: GRID_SIZE * 20, height: GRID_SIZE * 20 }}
      >
        {snake.map((seg, i) => (
          <div
            key={i}
            className="absolute bg-green-500 rounded-sm"
            style={{
              left: seg[0] * 20,
              top: seg[1] * 20,
              width: 20,
              height: 20,
            }}
          />
        ))}
        <div
          className="absolute bg-red-500 rounded-full"
          style={{
            left: food[0] * 20,
            top: food[1] * 20,
            width: 20,
            height: 20,
          }}
        />
      </div>
      {gameOver && (
        <div className="absolute bg-black/80 inset-0 flex flex-col items-center justify-center">
          <h2 className="text-red-500 text-5xl font-bold mb-4">GAME OVER</h2>
          <button
            onClick={() => {
              setSnake([[10, 10]]);
              setDir([0, -1]);
              setGameOver(false);
            }}
            className="px-6 py-2 bg-white rounded text-black font-bold"
          >
            Restart
          </button>
        </div>
      )}
    </div>
  );
}
